/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Badge, Modal, ModalBody, ModalFooter, Button } from 'react-bootstrap'; // eslint-disable-next-line
import Avatar from './Avatar';
import team2 from '../../assets/img/team/avatar.svg';
import UserProfileCardSection from './UserProfileCardSection';
import { copy } from './Common';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import config from '../config/config'; // eslint-disable-next-line
import { copiriPortalRequest, base64ToFileSync } from '../api/api';
// eslint-disable-next-line
import { copiriAxiosPost } from '../api/api'; // eslint-disable-next-line
import { toast } from 'react-toastify';
import { genPageData } from '../langconfig/langconfig'; // eslint-disable-next-line
const UserProfileTopSection = ({ data, pageLanguageContent, showCardSection, profileId, changeTab }) => {
	const [profileImage, setProfileImage] = useState(team2);
	const [showModal, setShowModal] = useState(false);
	const [cropImageUrl, setCropImageUrl] = useState(null);
	const [image, setImage] = useState(null);
	const [file, setFile] = useState(null);
	//const [crop, setCrop] = useState({ aspect: 1, unit: 'px', width: 200, height: 200, x: 0, y: 0 });

	const [crop, setCrop] = useState({
		unit: '%', // default, can be 'px' or '%'
		x: 0,
		y: 0,
		width: 100,
		height: 100
	});

	useEffect(() => {
		if (data) {
			setCrop({ unit: '%', x: 0, y: 0, width: 100, height: 100 });
		}
		// eslint-disable-next-line
	}, [data]);

	/* function to copy content*/
	function copyContent(content) {
		copy(content);
	}

	const closeModal = () => {
		setCrop({ unit: '%', x: 0, y: 0, width: 100, height: 100 });
		setShowModal(!showModal);
	};

	/* function to get image url for cropping and show modal */
	const getImageUrl = event => {
		setShowModal(!showModal);
		setCropImageUrl(URL.createObjectURL(event.target.files[0]));
		setFile(event.target.files[0]);
		event.target.value = '';
	};

	/* function to get cropped image and upload new image */
	function getCroppedImg() {
		const canvas = document.createElement('canvas');
		const scaleX = image.naturalWidth / image.width;
		const scaleY = image.naturalHeight / image.height;
		canvas.width = crop.width;
		canvas.height = crop.height;
		const ctx = canvas.getContext('2d');
		ctx.drawImage(
			image,
			crop.x * scaleX,
			crop.y * scaleY,
			crop.width * scaleX,
			crop.height * scaleY,
			0,
			0,
			crop.width,
			crop.height
		);

		// As Base64 string
		const base64Image = canvas.toDataURL('image/png');
		//uploadSlideImage(base64Image);
		setProfileImage(base64Image);
		//let fileObject = base64ToFileSync(base64Image, 'image');
		const formData = new FormData();
		formData.append('userimage', file);
		formData.append('source', 'profile');
		formData.append('id', profileId);
		formData.append('type', 'a');
		copiriPortalRequest('/images', config.app_version, 'post', formData, 'multipart/form-data')
			.then(response => {})
			.catch(error => {});

		setShowModal(!showModal);
	}

	/* function to trigger input file */
	function clickInputFile() {
		document.getElementById('uploadUserImage').click();
	}

	function changeUserTab(tab) {
		changeTab(tab);
	}

	return (
		<Row>
			<Col lg={3} className='text-center'>
				<Avatar
					src={profileImage}
					width={200}
					size='5xl'
					rounded='circle'
					className=' avatar-profile1'
					mediaClass='img-thumbnail shadow-sm'
				/>
				<div className='updateProfileDiv' style={{ right: '40px', fontSize: '18px', top: '2px' }}>
					<input type='file' onChange={getImageUrl} id='uploadUserImage' accept='.jpg, .jpeg, .png' hidden />
					<i className='fas fa-sync-alt inputReference' onClick={() => clickInputFile()}></i>
				</div>
			</Col>
			<Col lg={9}>
				<p className='modal-user-name'>
					{data['name_full'] ? data['name_full'] : pageLanguageContent['PRL033'] ? pageLanguageContent['PRL033'] : ''}
				</p>
				<span style={{ color: '#5e6e82' }}>
					Preferred Name:{' '}
					{data['name_pref'] ? data['name_pref'] : pageLanguageContent['PRL033'] ? pageLanguageContent['PRL033'] : ''}
				</span>
				<div className='modal-user-title'>
					<span className='title-text siteAccessLevel' onClick={() => changeUserTab('8')} role='button'>
						{pageLanguageContent['PRL077'] ? pageLanguageContent['PRL077'] : ''} :{' '}
						{!data['email_validated'] ? (
							<>{pageLanguageContent['PRL159'] ? pageLanguageContent['PRL159'] : ''}</>
						) : (
							<>{pageLanguageContent['PRL078'] ? pageLanguageContent['PRL078'] : ''}</>
						)}
					</span>
					<div className='userID_Uuid'>
						<span className='title-text' onClick={() => copyContent(data['id'])} role='button'>
							{' '}
							[ {data['id']} ]
						</span>
						<Badge
							bg={''}
							className='copy_content ml-1 memBadges badge badge-warning'
							onClick={() => copyContent(data['id'])}
							data-toggle='tooltip'
							title={genPageData['GENCPY'] ? genPageData['GENCPY'] : ''}
							role='button'
						>
							<i className='fas fa-copy' style={{ fontSize: '10px' }}></i>
						</Badge>

						<Badge
							className='copy_content  ml-1 memBadges badge badge-warning'
							bg={''}
							onClick={() => copyContent(data['uuid'])}
							data-toggle='tooltip'
							title={genPageData['GENCPY'] ? genPageData['GENCPY'] : ''}
							role='button'
						>
							<i className='fas fa-code copy_uuid' style={{ fontSize: '10px' }}></i>
						</Badge>
					</div>
				</div>
				<UserProfileCardSection data={data} pageLanguageContent={pageLanguageContent} />
			</Col>
			<Modal show={showModal} onHide={closeModal} size='md' className='addImg' id='croppedImageModal'>
				<ModalBody>
					<ReactCrop src={cropImageUrl} onImageLoaded={setImage} crop={crop} onChange={setCrop} keepSelection={true} />
				</ModalBody>
				<ModalFooter>
					<Button color='secondary' onClick={closeModal}>
						{pageLanguageContent['PRL063'] ? pageLanguageContent['PRL063'] : ''}
					</Button>
					<Button color='primary' onClick={getCroppedImg}>
						{pageLanguageContent['PRL160'] ? pageLanguageContent['PRL160'] : ''}
					</Button>
				</ModalFooter>
			</Modal>
		</Row>
	);
};
export default UserProfileTopSection;
